import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import { BuyNow } from "../../api/Product";
import { processRenewalOrder } from "../../api/EsimList";
import {
    Title,
    Subtitle,
    Divider,
    DetailsRow,
    DetailLabel,
    DetailValue,
    ButtonContainer,
    CancelButton,
    ConfirmButton,
} from "../../views/Pages/PortalPage/ConfirmationPage.elements";

class PurchaseConfirmModal extends Component {
    constructor(props) {
        super(props);
        this.state = { disableBtn: false };
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.setState({ disableBtn: false });
        }
    }

    getDayPassDays = (product) => {
        if (product.operatorId !== 2) return undefined;
        const isDayPass = product.productName.includes("/1");
        if (isDayPass) return "1";
        const parts = product.productName.split("/") || [];
        if (parts.length >= 2) {
            const validityPart = parts[parts.length - 1];
            const daysMatch = validityPart.match(/(\d+)/);
            if (daysMatch) return daysMatch[1];
        }
        return undefined;
    };

    handleConfirmPurchase = async () => {
        const { product, renewalContext } = this.props;

        if (renewalContext && product.isRenew) {
            await this.processRenewal();
        } else {
            await this.processNormalPurchase();
        }
    };

    processRenewal = async () => {
        const { product, renewalContext, history } = this.props;
        const dayPassDaysValue = this.getDayPassDays(product);

        const renewalOrderData = {
            ProductId: product.id,
            ParentOrderNum: renewalContext.parentOrderNum,
            ParentIccid: renewalContext.parentIccid,
            PriceId: product.productCode || "",
            SkuId: product.roamskuId || "",
            DayPassDays: dayPassDaysValue,
        };

        this.setState({ disableBtn: true });
        const result = await processRenewalOrder(renewalOrderData);

        if (result.status) {
            sessionStorage.removeItem("renewalContext");
            const renewalData = result.data || {};
            const orderData = renewalData.OrderData || renewalData.orderData;
            const orderIdentifier = orderData.orderNum || orderData.OrderNum;
            const iccdIdentifier = orderData.iccid || orderData.Iccid;
            const transactionId = orderData.TransactionId || orderData.transactionId;

            this.props.onCancel();
            history.push({
                pathname: "/home/purchaseSuccess",
                state: {
                    message: "Renewal completed successfully",
                    product: {
                        ...product,
                        orderNum: orderIdentifier,
                        iccid: iccdIdentifier,
                        transactionId: transactionId,
                        operatorId: 2,
                        isRenewal: true,
                    },
                    orderResult: result.data,
                },
            });
        } else {
            this.setState({ disableBtn: false });
            alert(result.message || "Renewal failed. Please try again.");
        }
    };

    processNormalPurchase = async () => {
        const { product, history } = this.props;
        let id = product.id ? product.id : product.productId;
        this.setState({ disableBtn: true });

        const dayPassDaysValue = this.getDayPassDays(product);

        const orderData = {
            skuId: product.roamskuId,
            priceId: product.productCode,
            count: "1",
        };
        if (dayPassDaysValue) {
            orderData.dayPassDays = dayPassDaysValue;
        }

        const productDetail = {
            operatorId: product.operatorId,
            productId: id,
            orderData: orderData,
        };

        try {
            const result = await BuyNow(productDetail);

            if (result.status) {
                const orderResultData =
                    result.data.OrderData || result.data.orderData || {};

                if (product.operatorId === 1) {
                    const orderTid = orderResultData.orderTid || orderResultData.OrderTid;
                    this.setState({ disableBtn: false });
                    this.props.onCancel();
                    if (orderTid) {
                        history.push({ pathname: `/home/joytel-detail/${orderTid}` });
                    } else {
                        alert(
                            "Order placed successfully but order ID was not returned. Please check My Products."
                        );
                        history.push({ pathname: "/home/list" });
                    }
                    return;
                }

                const orderIdentifier = orderResultData.orderNum || orderResultData.OrderNum;

                const productWithOrderInfo = {
                    ...product,
                    orderNum: orderIdentifier,
                    orderTid: orderIdentifier,
                    orderCode: orderResultData.orderCode || orderResultData.OrderCode,
                    transactionId: result.data.TransactionId || result.data.transactionId,
                    iccid: result.data.Iccid || result.data.iccid,
                    isRecharge: false,
                };

                this.setState({ disableBtn: false });
                this.props.onCancel();
                history.push({
                    pathname: "/home/purchaseSuccess",
                    state: {
                        message: "Purchase completed successfully!",
                        product: productWithOrderInfo,
                        orderResult: result.data,
                    },
                });
                return;
            } else {
                alert(result.message || "Purchase failed");
            }
        } catch (error) {
            console.error("Purchase error:", error);
            alert("An error occurred while processing your purchase.");
        }
        this.setState({ disableBtn: false });
    };

    render() {
        const { isOpen, product, onCancel } = this.props;
        const { disableBtn } = this.state;

        if (!product) return null;

        return (
            <Modal isOpen={isOpen} toggle={onCancel} centered>
                <ModalBody style={{ padding: "30px" }}>
                    <Title>Confirm Your Purchase</Title>
                    <Subtitle>Please review your order details before proceeding.</Subtitle>

                    <Divider />

                    <DetailsRow>
                        <DetailLabel xs={6}>Type Name</DetailLabel>
                        <DetailValue xs={6}>{product.typeName}</DetailValue>

                        <DetailLabel xs={6}>Name</DetailLabel>
                        <DetailValue xs={6}>{product.productName}</DetailValue>

                        <DetailLabel xs={6}>Price</DetailLabel>
                        <DetailValue xs={6}>
                            {Math.round(product.sellPrice).toLocaleString() + " MMK" || "N/A"}
                        </DetailValue>
                    </DetailsRow>

                    <ButtonContainer>
                        <CancelButton onClick={onCancel}>Cancel</CancelButton>
                        <ConfirmButton onClick={this.handleConfirmPurchase} disabled={disableBtn}>
                            Confirm Purchase
                        </ConfirmButton>
                    </ButtonContainer>
                </ModalBody>
            </Modal>
        );
    }
}

export default PurchaseConfirmModal;